import React, { useState, useEffect, useContext } from "react";
import { gql, useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { BtnPrimary, BtnAlternative } from "../buttons/Btn";
import { useAuth } from "../../../Context/AuthContext";
import { userContext } from "../../../Context/UserContext";

const LOGIN = gql`
    mutation tokenAuth($password: String!, $username: String) {
        tokenAuth(username: $username, password: $password) {
            success
            errors
            token
            refreshToken
            user {
                pk
                username
                profilePk
                initiatorProfilePk
            }
        }
    }
`;

function Login(props) {
    const [loginFunction, { data, loading, error }] = useMutation(LOGIN);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const { authRefDispatch, authAccDispatch, authUserDispatch } = useAuth();
    // const { user, setUser } = useContext(userContext);

    const onSubmit = (data) => {
        // console.log(data);
        if (data) {
            loginFunction({
                variables: {
                    username: data.emailLogin,
                    password: data.passwordLogin,
                },
            });
        }
    };

    useEffect(() => {
        if (data?.tokenAuth.success) {
            authRefDispatch({
                type: "LOGIN",
                refToken: data?.tokenAuth.refreshToken,
            });

            authAccDispatch({
                type: "LOGIN",
                accToken: data?.tokenAuth.token,
            });

            authUserDispatch({
                type: "LOGIN",
                username: data?.tokenAuth.user.username,
                adminId: data?.tokenAuth.user.initiatorProfilePk,
                userId: data?.tokenAuth.user.profilePk,
            });
            props.closeModal();
        }
        console.log(data);
    }, [data]);

    return (
        <div>
            <form
                className="flex flex-col gap-y-10"
                onSubmit={handleSubmit(onSubmit)}
            >
                <input
                    type="text"
                    placeholder="ایمیل یا شماره همراه*"
                    className="text-[1.8rem] bg-transparent rounded-16 border-2 border-[#C1BFC5] p-6 placeholder:text-[1.8rem] w-[44rem]"
                    {...register("emailLogin", {
                        required: true,
                    })}
                    control={control}
                />
                {errors.emailLogin?.type === "required" &&
                    alert("این فیلد نباید خالی باشد")}

                <input
                    type="password"
                    placeholder="رمز عبور*"
                    className="text-[1.8rem] bg-transparent rounded-16 border-2 border-[#C1BFC5] p-6 placeholder:text-[1.8rem] w-[44rem]"
                    {...register("passwordLogin", {
                        required: true,
                    })}
                    control={control}
                    autocomplete="on"
                />
                {errors.passwordLogin?.type === "required" &&
                    alert("رمز عبور خود را وارد کنید")}
                <BtnPrimary
                    text="ورود"
                    className=" self-end py-8 px-14"
                    type="submit"
                />
            </form>
        </div>
    );
}

export default Login;
